<template>
  <div :class="list_class">
    <SmartList ref="smart_list_component"
      @smartListItemsSet=onSmartListItemsSet
      :smart_list_items="folders_collapse_collection.items"
    >
        <template #elements>
            <div
                v-for='folder in smart_list_items'
                :key="folder.id"
                :title="folder.name"
                :class="{
                  'active'    : folders_selection_collection.index[folder.id],
                  'disabled'  : folders_disabled[folder.id],
                  [item_class]: true,
                  ['depth-' + folder.level] : true,
                }"
                v-context-menu="{
                  action: onContextMenu, data: folder
                }"
                v-drag-start="{
                  event: props.drag_start_event,
                  type: 'folder',
                  data: folder,
                }"
                v-drag-drop="{
                  drop_data: folder,
                  drop_suffix: props.drag_drop_suffix,
                  hover_class_active: props.drag_hover_active,
                  hover_events: props.drag_drop_events,
                }"
            >
                  <FolderItemCheck v-if="selection_box"
                    :folders_selection_collection="folders_selection_collection"
                    :folders_disabled="folders_disabled"
                    :selection_box="selection_box"
                    :folder="folder"
                    @folderRadioBoxCheck="onFolderRadioBoxCheck"
                    @folderCheckBoxCheck="onFolderCheckBoxCheck"
                  />

                  <FolderItemCollapsable
                    :folders_collapse_collection="folders_collapse_collection"
                    :folders_selection_collection="folders_selection_collection"
                    :folders_disabled="folders_disabled"
                    :list_type="list_type"
                    :folder="folder"
                    @folderToggleCollapse="onFolderToggleCollapse"
                    @folderClick="onFolderClick"
                  />
            </div>
        </template>
    </SmartList>
  </div>
</template>

<script setup>
  import {defineProps, defineExpose, defineEmits} from 'vue';
  import {ref}                                    from 'vue';
  import FolderItemCheck                          from './FolderItemCheck.vue';
  import FolderItemCollapsable                    from './FolderItemCollapsable.vue';
  import SmartList                                from '@/vue/Elements/Tools/SmartList.vue';

  const emit = defineEmits([
    'folderSelect', 'folderUnselect', 'folderExpand', 'folderCollapse', 'folderContextMenu', 'folderClick'
  ])

  const props = defineProps({
    folders_collapse_collection : {
      required: true,
    },

    folders_selection_collection : {},

    folders_disabled : {
      default : {}
    },

    selection_box : {
      default: null,
    },

    list_type : {
      default : 'router'
    },

    list_class : {
      default: 'folders-list'
    },

    item_class : {
      default: 'folder-item'
    },

    drag_start_event: {
      default: null,
    },

    drag_drop_events: {
      default: null,
    },

    drag_hover_active: {
      default: 'drag-over'
    },

    drag_drop_suffix: {
      default: null,
    }
  })

  const smart_list_items     = ref();
  const smart_list_component = ref();

  const onSmartListItemsSet = (items) => {
    setSmartListItems(items);
  }

  const setSmartListItems = (items) => {
    smart_list_items.value = items;
  }

  const scrollToItem = (item) => {
    smart_list_component.value.scrollToItem(item);
  }

  const onFolderToggleCollapse = (folder) => {
    props.folders_selection_collection.reset();

    if (props.folders_collapse_collection.isCollapsed(folder.id)) {
      props.folders_collapse_collection.expand(folder.id);
      emit('folderExpand', folder);
      return;
    }

    props.folders_collapse_collection.collapse(folder.id);
    emit('folderCollapse', folder);
  }

  const onFolderClick = (folder) => {
    if (props.selection_box === 'radio') {
      return onFolderRadioBoxCheck(folder);
    }

    if (props.selection_box === 'check') {
      return onFolderCheckBoxCheck(folder);
    }

    emit('folderClick', folder);
  }

  const onFolderRadioBoxCheck = (folder) => {
    if (props.folders_selection_collection.exists(folder.id)) {
      props.folders_selection_collection.delete(folder.id);
      emit('folderUnselect', folder);
      return;
    }

    props.folders_selection_collection.unique(folder);
    emit('folderSelect', folder);
  }

  const onFolderCheckBoxCheck = (folder) => {
    if (props.folders_selection_collection.exists(folder.id)) {
      props.folders_selection_collection.delete(folder.id);
      emit('folderUnselect', folder);
      return;
    }

    props.folders_selection_collection.add(folder);
    emit('folderSelect', folder);
  }

  const onContextMenu = (folder) => {
    emit('folderContextMenu', folder);
  }

  defineExpose({
    scrollToItem: scrollToItem,
  })
</script>